<template>
  <b-row>
    <b-col sm="12" md="4">
      <b-form-group>
        <label>{{$t("views.agreements.form.signedDate")}}:</label>
        <VueCtkDateTimePicker no-header
                              id="input_signedDate"
                              :label="$t('views.agreements.form.signedDate')"
                              v-model="data.signedDate"
                              format="YYYY-MM-DD"
                              :noButtonNow="true"
                              :onlyDate="true"
                              :right="true"
                              formatted="ll"
                              :no-label="true"
        >
        </VueCtkDateTimePicker>
      </b-form-group>
    </b-col>
    <b-col sm="12" md="4">
      <b-form-group>
        <label>{{$t("views.agreements.form.dateFrom")}}:</label>
        <VueCtkDateTimePicker no-header
                              id="input_dateFrom"
                              :label="$t('views.agreements.form.dateFrom')"
                              v-model="data.dateFrom"
                              format="YYYY-MM-DD"
                              :noButtonNow="true"
                              :onlyDate="true"
                              :right="true"
                              formatted="ll"
                              :no-label="true"
                              @input="dateFromInput($event)"
        >
        </VueCtkDateTimePicker>
      </b-form-group>
    </b-col>
    <b-col sm="12" md="4" v-if="data.timelessAgreement === 0">
      <label>{{$t("views.agreements.form.agreementLength")}}:</label>
      <b-form-group>
        <b-form-radio-group buttons button-variant="outline-primary" id="agreement_length" v-model="agreementLength">
          <b-form-radio button-variant="outline-primary" :value="12">{{$t("views.agreements.form.12months")}}</b-form-radio>
          <b-form-radio button-variant="outline-primary" :value="24">{{$t("views.agreements.form.24months")}}</b-form-radio>
          <b-form-radio button-variant="outline-primary" :value="0">{{$t("views.agreements.form.other")}}</b-form-radio>
        </b-form-radio-group>
      </b-form-group>
    </b-col>
    <b-col sm="12" md="4">
      <b-form-group>
        <label>{{$t("views.agreements.form.dateTo")}}:</label>
        <VueCtkDateTimePicker no-header
                              id="input_dateTo"
                              :label="$t('views.agreements.form.dateTo')"
                              v-model="data.dateTo"
                              format="YYYY-MM-DD"
                              :noButtonNow="true"
                              :onlyDate="true"
                              :right="true"
                              formatted="ll"
                              :no-label="true"
                              v-if="data.timelessAgreement === 0"
                              @input="dateToInput($event)"
        >
        </VueCtkDateTimePicker>
      </b-form-group>
      <b-form-group>
        <b-form-checkbox
          v-model="data.timelessAgreement"
          name="timelessAgreement"
          :value="1"
          :unchecked-value="0"
        >
        <span>
          {{$t('views.agreements.form.timelessAgreement')}}
        </span>
        </b-form-checkbox>
      </b-form-group>
    </b-col>
    <b-col>
      <b-form-group>
        <label for="customSymbol">{{$t("views.agreements.form.customSymbol")}}:</label>
        <input v-model="data.customSymbol"
               name="customSymbol" type="text"
               autofocus :placeholder="$t('views.agreements.form.customSymbol')"
               class="form-control" id="customSymbol"/>
      </b-form-group>
    </b-col>
    <b-col>
      <b-form-group>
        <label>{{$t("views.agreements.form.serviceDateFrom")}}:</label>
        <VueCtkDateTimePicker no-header
                              id="input_serviceDateFrom"
                              :label="$t('views.agreements.form.serviceDateFrom')"
                              v-model="data.serviceDateFrom"
                              format="YYYY-MM-DD"
                              :noButtonNow="true"
                              :onlyDate="true"
                              :right="true"
                              formatted="ll"
                              :no-label="true"
        >
        </VueCtkDateTimePicker>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

export default {
  name: 'DatesSettings',
  data () {
    return {
      agreementLength: 0
    }
  },

  watch: {
    agreementLength (val) {
      if (val === 12 || val === 24) {
        this.data.dateTo = this.$moment(this.data.dateFrom).add(val, 'months').format('YYYY-MM-DD')
      } else {
        this.data.dateTo = null
      }
    },
    timelessAgreement (val) {
      if (val === 1) this.data.dateTo = null
    }
  },

  methods: {
    dateFromInput (date) {
      this.agreementLength = 0
      this.$forceUpdate()
      this.data.dateFrom = date
    },
    dateToInput (date) {
      this.agreementLength = 0
      this.$forceUpdate()
      this.data.dateTo = date
    }
  },

  components: {
    VueCtkDateTimePicker
  },
  props: ['data', 'violations', 'isInvalid']
}
</script>
